/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated: February 2026`)
};

const es_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización: Febrero 2026`)
};

const de_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert: Februar 2026`)
};

const nl_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt: februari 2026`)
};

const fr_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour : février 2026`)
};

const it_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento: febbraio 2026`)
};

const pt_br2_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização: Fevereiro de 2026`)
};

const pt_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização: fevereiro de 2026`)
};

const ja_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新: 2026年2月`)
};

const zh_privacy_last_updated = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新：2026年2月`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_last_updated = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_last_updated(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_last_updated", locale)
	if (locale === "en") return en_privacy_last_updated(inputs)
	if (locale === "es") return es_privacy_last_updated(inputs)
	if (locale === "de") return de_privacy_last_updated(inputs)
	if (locale === "nl") return nl_privacy_last_updated(inputs)
	if (locale === "fr") return fr_privacy_last_updated(inputs)
	if (locale === "it") return it_privacy_last_updated(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_last_updated(inputs)
	if (locale === "pt") return pt_privacy_last_updated(inputs)
	if (locale === "ja") return ja_privacy_last_updated(inputs)
	return zh_privacy_last_updated(inputs)
};